// import { createApp } from "vue";
import App from "./App.vue";
// import router from "./router";
import { i18n } from "./i18n";
import { createPinia } from "pinia";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { ViteSSG } from "vite-ssg";
import "@/assets/css/main.css";
import { routes } from "./router";
const pinia = createPinia();
export const createApp = ViteSSG(
  App,
  {
    routes,
    scrollBehavior() {
      return { top: 0 };
    },
  },
  ({ app }) => {
    const options = {
      position: "bottom-right",
      timeout: 5000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: false,
      hideProgressBar: true,
      closeButton: false,
      icon: false,
      rtl: false,
      toastClassName: "my-custom-toast-class",
    };

    app.use(Toast, options);

    app.use(pinia);
    app.use(i18n);
  }
);
// const head = createHead();

// app.use(router);
